import type { BoundObjectRef } from '@wix/editor-platform-feature-store';
import type {
  ElementSort,
  SelectSortParams,
} from '@wix/public-editor-platform-interfaces';
import type { SelectSortPanelOptions } from '@wix/editor-platform-host-integration-apis';

import { PlatformPrivateServices } from '../../../PlatformPrivateServices';

export type ISelectSortParams = SelectSortParams;

export class HostSortSelectorAPI {
  constructor(private ps: PlatformPrivateServices) {}

  async selectSort(
    dataItemKey: string,
    context: {
      target: BoundObjectRef;
      providerIdentifier?: string;
      onChange: SelectSortPanelOptions['onChange'];
    },
  ): Promise<ElementSort | undefined> {
    const panelOptions: SelectSortPanelOptions = {
      sortDataItemKey: dataItemKey,
      onChange: context.onChange,
      ...(context.providerIdentifier
        ? { providerIdentifier: context.providerIdentifier }
        : {}),
    };

    // TODO: Add explicit-options mode when `SelectSortParams` supports passing
    // value and callbacks. In that mode, the panel should only manage UI state
    // and return the selected sort to the consumer without SDK persistence.
    if (this.ps.hostAPI.editor.selectSort) {
      return this.ps.hostAPI.editor.selectSort(context.target, panelOptions);
    }

    const wqlSortModalUIService =
      this.ps.platformPackagesBridge.WqlSortModalUIServiceAPI;

    if (wqlSortModalUIService) {
      return new Promise<ElementSort | undefined>((resolve) => {
        const editorPointer = context.target.editorPointer as Parameters<
          typeof wqlSortModalUIService.openPanel
        >[0]['editorPointer'];

        const openPanelProps = {
          editorPointer,
          onChange: async (nextValue: ElementSort) => {
            const updatedValue = await panelOptions.onChange(nextValue);
            resolve(updatedValue);
            return updatedValue;
          },
          ...(panelOptions.providerIdentifier
            ? { providerIdentifier: panelOptions.providerIdentifier }
            : {}),
          sortDataItemKey: panelOptions.sortDataItemKey,
        };

        wqlSortModalUIService.openPanel(openPanelProps);
      });
    }

    throw new Error('selectSort panel is not supported');
  }
}
